import React from '@byted-lynx/react-runtime';
import type { LexerToken } from '../typings/index';
import { lexerCommonHandler, resolvePayload } from '../utils';

export type IReplaceHandlerPayload = (replaceKey: string, ...args) => React.ReactNode;
export type IPayload =
  | (number | string | React.ReactNode)
  | IReplaceHandlerPayload
  | Record<string, (number | string) | IReplaceHandlerPayload>;

export default {
  type: 'replace',
  handle: (tokenList: LexerToken[], payload: IPayload) =>
    lexerCommonHandler(tokenList, /(\{)(.+?)(\})/g, rawTokens => {
      const splitTokens: LexerToken[] = [];
      for (let i = 0; i < rawTokens.length;) {
        const p = rawTokens[i];
        const n = rawTokens[i + 1];
        const nn = rawTokens[i + 2];
        if (p === '{' && nn === '}') {
          const raw = p + n + nn;
          const result = resolvePayload<IPayload>(payload, n);
          splitTokens.push({
            type: 'replace',
            raw,
            content: typeof result === 'undefined' || result === null ? raw : result,
          });
          i += 3;
        } else {
          // 会存在空字符
          if (p) {
            splitTokens.push({
              type: 'text',
              raw: p,
              content: p,
            });
          }
          i++;
        }
      }
      return splitTokens;
    }),
};
